<template>
  <b-container>
    <Breadcrumbs crumbString="What We Do,Identification & Wayfinding"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          enviroSIGNS has developed a wide variety of identification and wayfinding signs.
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-5 col-md-5 image-pod">
              <div class="img wayfinding-169-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/wayfinding/identification-sign-duraReader.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-7 col-md-7">
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img wayfinding-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/wayfinding/identification-sign-CHPL.jpg') + ')'}"></div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 col-md-7 col-md-7 image-pod">
                  <div class="img wayfinding-100-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/wayfinding/identification-sign-redwood.jpg') + ')'}"></div>
                </b-col>
                <b-col class="col-12 col-md-5 col-md-5 image-pod">
                  <div class="img wayfinding-142-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/wayfinding/wayfinding-sign-anodized-aluminum.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-md-5 image-pod">
              <div class="img wayfinding-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/wayfinding/city-wayfinding-sign-galvanized-steel.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-7 col-md-7 image-pod">
              <div class="img wayfinding-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/wayfinding/identification-sign-color-core.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Identification & Wayfinding'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/whatWeDo/Wayfinding.vue